import { CseRegistration } from '../../lib/types/models/cse/cse-reduction'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCseRegistration(enrollmentId: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getCseRegistration.url, { id: enrollmentId }))
    .get<CseRegistration | null>()
}
